import { ButtonSecondary } from 'components/Button'
import { useIsFarmAdmin } from 'pages/Liquidity/hooks/useIsFarmAdmin'
import { useNavigate } from 'react-router-dom'
import { Address } from 'viem'
// import { Button } from 'rebass'

export function ConfigureButton({ farmAddress }: { farmAddress: Address }) {
  const navigate = useNavigate()
  const { isAdmin, loading } = useIsFarmAdmin(farmAddress)

  if (loading || !isAdmin) return null
  // 'liquidity/farms/configure/'
  return (
    <ButtonSecondary
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        navigate(`configure/${farmAddress}`)
      }}
      padding="4px"
      $borderRadius="2px"
      style={{
        fontSize: '12px',
      }}
    >
      Configure
    </ButtonSecondary>
  )
}
